// Pure logic for the image-upload queue. Kept free of React so the slot math
// and rejection messaging that broke #432/#447 are unit-testable.

export const isHeic = (file) =>
  /heic|heif/i.test(file?.type || '') || /\.(heic|heif)$/i.test(file?.name || '');

// Decide what to do with a drop: how many files fit, which get skipped, and
// the messages the user must see (the old dropzone rejected whole batches
// silently — #432).
export const planDrop = ({ currentCount, maxImages, accepted = [], rejections = [] }) => {
  const slots = Math.max(0, maxImages - currentCount);
  const toProcess = accepted.slice(0, slots);
  const notices = [];

  const overflow = accepted.length - toProcess.length;
  if (overflow > 0) {
    notices.push(
      slots === 0
        ? `This already has the maximum of ${maxImages} image${maxImages === 1 ? '' : 's'} — delete one to add more.`
        : `Only ${slots} more image${slots === 1 ? '' : 's'} can be added (max ${maxImages}); ${overflow} file${overflow === 1 ? ' was' : 's were'} skipped.`
    );
  }

  for (const rejection of rejections) {
    const codes = (rejection.errors || []).map((e) => e.code);
    const name = rejection.file?.name || 'A file';
    if (codes.includes('file-invalid-type')) {
      notices.push(`"${name}" isn't a supported image type.`);
    } else if (codes.includes('file-too-large')) {
      notices.push(`"${name}" is too large.`);
    } else if (codes.includes('too-many-files')) {
      // handled via slot math above; avoid double-reporting per file
      continue;
    } else {
      notices.push(`"${name}" couldn't be added.`);
    }
  }

  return { toProcess, notices, slots };
};

// stable id for queue entries (files can share names)
let uid = 0;
export const nextQueueId = () => `q_${Date.now().toString(36)}_${uid++}`;
